import React, { useState, useEffect } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import { experienceService } from '../../../services/experienceService';

const ExperienceTimeline = () => {
  const [experiences, setExperiences] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchExperience();
  }, []);

  const fetchExperience = async () => {
    try {
      const data = await experienceService?.getAllExperience();
      setExperiences(data || []);
    } catch (error) {
      console.error('Error fetching experience:', error);
      setExperiences([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="py-12 md:py-16 lg:py-20 bg-muted/30">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent mx-auto mb-4"></div>
            <p className="text-muted-foreground">Loading experience...</p>
          </div>
        </div>
      </section>
    );
  }

  if (experiences?.length === 0) {
    return null;
  }

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <span className="inline-block px-4 py-2 bg-accent/10 text-accent rounded-full text-sm md:text-base font-medium mb-4">
            Career Journey
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Work Experience
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            A timeline of professional growth and achievements
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-border transform -translate-x-1/2"></div>

          <div className="space-y-8 md:space-y-12">
            {experiences?.map((exp, index) =>
            <div
              key={exp?.id}
              className={`relative flex flex-col lg:flex-row gap-6 md:gap-8 ${
              index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`
              }>

                <div className="lg:w-1/2 lg:pr-8">
                  <div className="bg-card rounded-xl md:rounded-2xl p-6 md:p-8 border border-border hover:border-accent/50 transition-all duration-300 hover:shadow-lg">
                    <div className="flex items-start gap-4 mb-4">
                      <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-lg md:rounded-xl overflow-hidden border-2 border-border">
                        <Image
                        src={exp?.logo}
                        alt={exp?.logoAlt}
                        className="w-full h-full object-cover" />

                      </div>
                      <div className="flex-1 min-w-0">
                        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1">
                          {exp?.role}
                        </h3>
                        <p className="text-base md:text-lg text-accent font-medium mb-2">
                          {exp?.company}
                        </p>
                        <div className="flex flex-wrap gap-2 text-xs md:text-sm text-muted-foreground">
                          <span className="flex items-center gap-1">
                            <Icon name="Calendar" size={14} />
                            {exp?.period}
                          </span>
                          <span>•</span>
                          <span className="flex items-center gap-1">
                            <Icon name="Clock" size={14} />
                            {exp?.duration}
                          </span>
                          <span>•</span>
                          <span className="flex items-center gap-1">
                            <Icon name="MapPin" size={14} />
                            {exp?.location}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="space-y-2">
                      {exp?.achievements?.map((achievement, idx) =>
                    <div key={idx} className="flex items-start gap-2">
                          <Icon
                        name="CheckCircle2"
                        size={16}
                        color="var(--color-accent)"
                        className="flex-shrink-0 mt-1" />

                          <p className="text-sm md:text-base text-muted-foreground">
                            {achievement}
                          </p>
                        </div>
                    )}
                    </div>

                    <div className="mt-4 pt-4 border-t border-border">
                      <span className="inline-block px-3 py-1 bg-accent/10 text-accent text-xs md:text-sm rounded-full">
                        {exp?.type}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="hidden lg:flex lg:w-12 items-center justify-center">
                  <div className="w-4 h-4 bg-accent rounded-full border-4 border-background shadow-lg"></div>
                </div>

                <div className="hidden lg:block lg:w-1/2"></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default ExperienceTimeline;